import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, GraduationCap, BookOpen, Shield, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingCRFPA = () => {
  const { language } = useLanguage();

  const features = language === 'fr' ? [
  'Maîtriser ChatGPT, Claude et Gemini pour structurer ses révisions',
  'Savoir identifier et vérifier les hallucinations de l\'IA',
  'Utiliser l\'IA comme complément à une préparation méthodique',
  'Automatiser la recherche de jurisprudence et de doctrine',
  'Respecter les principes déontologiques dès la préparation'] :
  [
  'Master ChatGPT, Claude and Gemini to structure your study plan',
  'Identify and verify AI hallucinations',
  'Use AI as a complement to rigorous preparation',
  'Automate case law and doctrine research',
  'Respect ethical principles from day one'];


  return (
    <section className="py-20 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          {/* Image */}
          <div className="mb-10 lg:mb-0">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                alt={language === 'fr' 
                  ? "Formation IA CRFPA : masterclass ChatGPT Claude Gemini pour préparation examen avocat barreau - pré barreau IA révisions FCO CPF FIF-PL" 
                  : "CRFPA Legal AI Masterclass: ChatGPT Claude Gemini bar exam preparation - legal AI training CLE CPF"}
                title={language === 'fr' 
                  ? "Masterclass IA juridique spéciale CRFPA - Formation ChatGPT Claude Gemini pour étudiants en droit et candidats au barreau | Gaius" 
                  : "Special CRFPA Legal AI Masterclass - ChatGPT Claude Gemini training for law students and bar candidates | Gaius"}
                loading="lazy"
                decoding="async"
                width={800}
                height={800}
                className="w-full h-auto object-cover"
                src={language === 'fr' ? "/images/crfpa-masterclass-chatgpt-fr.webp" : "/images/crfpa-masterclass-chatgpt-en.webp"} />

            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 mb-4">
              <GraduationCap className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary">
                {language === 'fr' ? 'Nouveau' : 'New'}
              </span>
            </div>

            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              {language === 'fr' ?
              'Formations IA spéciales CRFPA' :
              'Special CRFPA AI Training'}
            </h2>

            <h3 className="text-xl text-primary font-semibold mb-4">
              {language === 'fr' ?
              'L\'IA au service de votre préparation au barreau' :
              'AI at the service of your bar exam preparation'}
            </h3>

            <p className="text-lg text-muted-foreground mb-4 leading-relaxed">
              {language === 'fr' ?
              'L\'examen du CRFPA exige une préparation rigoureuse et méthodique. L\'intelligence artificielle ne remplace pas le travail de fond — elle l\'augmente. Nos formations apprennent aux étudiants et candidats à utiliser ChatGPT, Claude et Gemini comme outils complémentaires pour structurer leurs révisions, vérifier leurs connaissances et optimiser leur temps de préparation.' :
              'The CRFPA exam demands rigorous, methodical preparation. AI doesn\'t replace the hard work — it enhances it. Our training teaches students and candidates to use ChatGPT, Claude and Gemini as complementary tools to structure their revision, verify their knowledge and optimize preparation time.'}
            </p>

            <p className="text-base text-muted-foreground mb-6 leading-relaxed">
              {language === 'fr' ?
              'Conçues en collaboration avec des avocats formateurs et des préparations au CRFPA, ces formations mettent l\'accent sur la fiabilité, la vérification anti-hallucinations et le respect strict de la déontologie. L\'objectif : faire de l\'IA un allié fiable, pas une béquille dangereuse.' :
              'Designed in collaboration with lawyer-trainers and CRFPA prep courses, these programs emphasize reliability, anti-hallucination verification and strict ethical compliance. The goal: make AI a reliable ally, not a dangerous crutch.'}
            </p>

            <ul className="space-y-3 mb-8">
              {features.map((feature, i) =>
              <li key={i} className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-muted-foreground">{feature}</span>
                </li>
              )}
            </ul>

            <Button asChild size="lg" className="bg-primary hover:bg-primary/90">
              <Link to={language === 'fr' ? '/reservation-formation-crfpa' : '/book-crfpa-ai-training'} className="flex items-center gap-2">
                {language === 'fr' ? 'Réserver ma session IA' : 'Book my AI training session'}
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>);

};